module.exports = __webpack_public_path__ + "img/e_3_7_g.dee5240e.png";